module.exports = __webpack_public_path__ + "src/img/tab.4f464453.png";